import { SegmentedControl } from '@ui'
import React from 'react'

export type BorrowLendTab = 'lending' | 'borrowing'

interface TabSelectorProps {
  activeTab: BorrowLendTab
  onTabChange: (tab: BorrowLendTab) => void
  labels: {
    lending: string
    borrowing: string
  }
}

export const TabSelector: React.FC<TabSelectorProps> = ({ activeTab, onTabChange, labels }) => {
  return (
    <SegmentedControl
      value={activeTab}
      onChange={onTabChange}
      fullWidth
      aria-label={`${labels.lending} / ${labels.borrowing}`}
      options={(['lending', 'borrowing'] as const).map((tab) => ({
        value: tab,
        label: labels[tab],
      }))}
    />
  )
}

export default TabSelector
